// Generated by scripts/update-seeq-icons.js from src/svg/seeq/edit.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcEdit = {
  prefix: 'fak',
  iconName: 'edit' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e94b',
    'M865.3 235.5c15.4 15.4 30.7 25.6 46.1 30.7l87-87c30.7-30.7 20.5-92.2-20.5-138.2v0c-46.1-46.1-107.5-56.3-138.2-20.5l-76.8 81.9c25.6 51.2 61.4 97.3 102.4 133.1zM41 1024l204.8-87 624.6-619.6c-10.2-5.1-25.6-15.4-35.8-25.6-51.2-41-92.2-87-117.8-143.3l-604.2 604.1c20.5 30.7 46.1 66.6 61.5 76.8 20.5 10.2 30.7 35.8 25.6 51.2s-30.7 20.5-46.1 10.3c-25.6-15.4-51.2-46.1-76.8-81.9l-76.8 174c-5.1 20.5 20.5 46.1 41 41z',
  ],
} satisfies IconDefinition;
